<template>
	<a :href="`${baseUrl}checklist/${subId}`" class="Checklist"><time :datetime="date"><strong>{{ dateDisplay }}</strong> {{ timeDisplay }}</time></a>
</template>

<script>
export default {
	name: 'Count',
	components: {},
	props: {
		subId: {
			type: String,
			required: true,
		},
		date: {
			type: String,
			required: true,
		},
		locale: {
			type: String,
			default: 'en-US',
		},
		baseUrl: {
			type: String,
			default: 'https://ebird.org/',
		}
	},
	computed: {
		dateDisplay() {
			// Debug for safari
			const dateObj = new Date(this.fixDateString(this.date));
			let formattedDay = dateObj.toLocaleDateString(this.locale, { day: 'numeric' });
			let formattedMonth = dateObj.toLocaleDateString(this.locale, { month: 'short' });
			let formattedYear = dateObj.toLocaleDateString(this.locale, { year: 'numeric' });
			return `${formattedDay} ${formattedMonth} ${formattedYear}`;
		},
		timeDisplay() {
			let formattedTime = new Date(this.fixDateString(this.date)).toLocaleTimeString(this.locale, { hour: 'numeric', minute: 'numeric', hour12: false });
			return formattedTime;
		},
	},
	data() {
		return {

		};
	},
	methods: {
		fixDateString(dateString) {
			const dateParts = dateString.split(" ");
			return `${dateParts[0]}T${dateParts[1]}`;
		}
	}
};
</script>

<style lang="scss">
	.Checklist {
		
	}
</style>
